import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/deliver.png'


const _withScopeId = n => (_pushScopeId("data-v-6b63cfea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gift-preview" }
const _hoisted_2 = { class: "gift-image" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "deliver",
  src: _imports_0,
  alt: "送"
}, null, -1))

import {IActivityGift} from "@/app/editor/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'GiftPreview',
  props: {
    gift: {},
    amount: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_typography_title, { level: 4 }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.gift.name) + _toDisplayString(_ctx.amount ? 'x' + _ctx.amount : ''), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "gift",
        src: _ctx.gift.image_url,
        alt: ""
      }, null, 8, _hoisted_3),
      _hoisted_4
    ])
  ]))
}
}

})